module.exports = __webpack_public_path__ + "img/light_0.dcb81ad8.png";